import { render } from "./AutoVerificationServices.vue?vue&type=template&id=0e95054e&scoped=true"
import script from "./AutoVerificationServices.vue?vue&type=script&lang=js"
export * from "./AutoVerificationServices.vue?vue&type=script&lang=js"

import "./AutoVerificationServices.vue?vue&type=style&index=0&id=0e95054e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e95054e"]])

export default __exports__